import { __assign, __rest } from "tslib";
export * from './team-performance';
export * from './chat';
export * from './dto';
export var createInsightsApi = function (baseUrl, http) {
    var apiUrl = baseUrl + '/analytics';
    var articleUrl = apiUrl + '/article';
    var topIssuesUrl = apiUrl + '/topIssues';
    var topIssuesByCategoriesUrl = topIssuesUrl + '/categories';
    var ticketsUrl = apiUrl + '/tickets';
    var topIssueOveriewUrl = function (id) { return articleUrl + '/' + id; };
    var ticketStatsOverviewUrl = ticketsUrl + '/stats';
    var ticketStatsHistogramUrl = ticketStatsOverviewUrl + '/histogram';
    var ticketInsightsUrl = ticketsUrl + '/insights';
    var performanceUrl = apiUrl + '/tickets/performance';
    var agentsPerformanceUrl = performanceUrl + '/agents';
    var groupsPerformanceUrl = performanceUrl + '/groups';
    var agentPerformanceUrl = function (id) { return agentsPerformanceUrl + "/".concat(id); };
    var agentHistogramUrl = function (id) { return performanceUrl + "/agents/".concat(id, "/histogram"); };
    var groupPerformanceUrl = function (id) { return groupsPerformanceUrl + "/".concat(id); };
    var groupHistogramUrl = function (id) { return performanceUrl + "/groups/".concat(id, "/histogram"); };
    var kbOverviewUrl = apiUrl + '/overview';
    var kbHistogramUrl = kbOverviewUrl + '/histogram';
    var mostReadArticlesUrl = articleUrl + '/mostRead';
    var mostHelpfulArticlesUrl = articleUrl + '/mostHelpful';
    var mostUnhelpfulArticlesUrl = articleUrl + '/mostUnhelpful';
    var topFeatureRequestsUrl = articleUrl + '/topFeatureRequests';
    var topKnownIssuesUrl = articleUrl + '/topKnownIssues';
    var searchTermUrl = apiUrl + '/search';
    var topSearchTermsUrl = searchTermUrl + '/popular';
    var topUnanswersSearchTermsUrl = searchTermUrl + '/mostUnanswered';
    var extendedSearchTermUrl = searchTermUrl + '/extended';
    var pageSize = 200; //magic number
    return {
        getTopIssues: function (dto) {
            return http.post(topIssuesUrl, dto);
        },
        getTopIssuesByCategories: function (dto) {
            return http.post(topIssuesByCategoriesUrl, dto);
        },
        getTopIssueOverview: function (dto) {
            return http.post(topIssueOveriewUrl(dto.articleId), dto);
        },
        getTicketStatsOverview: function (dto) {
            return http.post(ticketStatsOverviewUrl, dto);
        },
        getTicketStatsHistogram: function (dto) {
            return http.post(ticketStatsHistogramUrl, __assign(__assign({}, dto), { pageSize: pageSize }));
        },
        getTicketInsights: function (dto) {
            return http.post(ticketInsightsUrl, dto);
        },
        getAgentsTicketsPerformance: function (dto) {
            var groupId = dto.groupId, rest = __rest(dto, ["groupId"]);
            return groupId ?
                http.post(agentsPerformanceUrl, __assign(__assign({}, rest), { groupId: groupId }))
                : http.post(agentsPerformanceUrl, __assign({}, rest));
        },
        getAgentTicketsPerformance: function (dto) {
            return http.post(agentPerformanceUrl(dto.id), dto)
                .then(function (res) { return res[0]; });
        },
        getAgentTicketsHistogram: function (dto) {
            return http.post(agentHistogramUrl(dto.userId), __assign(__assign({}, dto), { pageSize: pageSize }));
        },
        getGroupTicketsPerformance: function (dto) {
            return http.post(groupPerformanceUrl(dto.id), dto)
                .then(function (res) { return res[0]; });
        },
        getGroupTicketsHistogram: function (dto) {
            return http.post(groupHistogramUrl(dto.groupId), __assign(__assign({}, dto), { pageSize: pageSize }));
        },
        getGroupsTicketsPerformance: function (dto) {
            return http.post(groupsPerformanceUrl, dto);
        },
        getKbStatsOverview: function (dto) {
            return http.post(kbOverviewUrl, dto);
        },
        getKbStatsHistogram: function (dto) {
            return http.post(kbHistogramUrl, __assign(__assign({}, dto), { pageSize: pageSize }));
        },
        getMostReadArticles: function (dto) {
            return http.post(mostReadArticlesUrl, dto);
        },
        getMostHelpfulArticles: function (dto) {
            return http.post(mostHelpfulArticlesUrl, dto);
        },
        getMostUnhelpfulArticles: function (dto) {
            return http.post(mostUnhelpfulArticlesUrl, dto);
        },
        getTopFeatureRequests: function (dto) {
            return http.post(topFeatureRequestsUrl, dto);
        },
        getTopKnownIssues: function (dto) {
            return http.post(topKnownIssuesUrl, dto);
        },
        getTopSearchTerms: function (dto) {
            return http.post(topSearchTermsUrl, dto);
        },
        getTopUnansweredSearchTerms: function (dto) {
            return http.post(topUnanswersSearchTermsUrl, dto);
        },
        getExtendedSearchTerm: function (dto) {
            return http.post(extendedSearchTermUrl, dto);
        },
    };
};
//# sourceMappingURL=index.js.map